import React from 'react';
import * as PropTypes from 'prop-types';
import helpers from "../../helpers/helpers";

const Input = ({
  label,
  labelAdditional,
  name,
  type,
  placeholder,
  value,
  onChange,
  description,
  isDisabled,
  error,
  required,
  errorText,
  className,
  inputClassName
}) => {
  const id = `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;

  const {getTranslationText} = helpers;

  return (
    <div className={`form-field ${error ? 'error' : ''} ${className ? className : ''}`}>
      <label htmlFor={id}>
        {getTranslationText(label)}
        {required && (
            <span className="text-required">*</span>
        )}
      </label>
      {description && (
          <div
              className='form-description'
              dangerouslySetInnerHTML={{__html: getTranslationText(description)}}
          />
      )}
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        disabled={isDisabled}
        onChange={onChange}
        autoComplete="off"
        name={name}
        className={`${inputClassName ? inputClassName : ''}`}
      />
      {labelAdditional && (
        <span className="form-field__label-additional">{labelAdditional}</span>
      )}
      {errorText && (
        <span className="form-field__error">{errorText}</span>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  labelAdditional: PropTypes.string || PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  error: PropTypes.bool || PropTypes.string,
  errorText: PropTypes.string,
};

Input.defaultProps = {
  label: '',
  labelAdditional: '',
  name: '',
  type: 'text',
  placeholder: '',
  onChange: () => {},
  isDisabled: false,
  error: false,
  errorText: '',
};

export default Input;
